import { render, staticRenderFns } from "./SumUpPaymentModal.vue?vue&type=template&id=db044578&scoped=true&"
import script from "./SumUpPaymentModal.vue?vue&type=script&lang=js&"
export * from "./SumUpPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./SumUpPaymentModal.vue?vue&type=style&index=0&id=db044578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db044578",
  null
  
)

export default component.exports